// extracted by mini-css-extract-plugin
export default {"modal_container":"AddDiagnosis_modal_container__hc9LA","custom_modal":"AddDiagnosis_custom_modal__OusHJ","black_overlay":"AddDiagnosis_black_overlay__RZFhC"};